import request from '../request';

/**
 * 百科详情--下一条
 */
export function wikiNext(obj){
    return request({
        url:'/zs/wiki/webWikiNext',
        method:'get',
        params:obj
    })
}
/**
 * 百科详情信息
 */
export function wikiDetail(obj){
    return request({
        url:'/zs/wiki/wikiDetail',
        method:'get',
        params:obj
    })
}
/**
 * 百科分页
 */
export function wikiList(obj){
    return request({
        url:'/zs/wiki/wikiList',
        method:'get',
        params:obj
    })
}
/**
 * 百科推荐10条
 */
export function wikiTopTen(obj){
    return request({
        url:'/zs/wiki/wikiTopTen',
        method:'get',
        params:obj
    })
}


// WEBPACK FOOTER //
// ./src/api/http/wiki.js